/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronsDoubleDown: {
  name: 'chevrons-double-down';
  data: string;
} = {
  name: 'chevrons-double-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.354 2.646a.5.5 0 1 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0-.708-.708L8 6.293 4.354 2.646Zm0 6a.5.5 0 1 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0-.708-.708L8 12.293 4.354 8.646Z" fill="currentColor"/></svg>`,
};
